import { TableHeader } from "./TableHeader";
import { TableItem } from "./TableItem";
import { TableItemsWrapper } from "./TableItemsWrapper";
import { TableItemWithHeader } from "./TableItemWithHeader";

import { TableRoot } from "./TableRoot";

export const Table = {
  Header: TableHeader,
  Item: TableItem,
  ItemWithHeader: TableItemWithHeader,
  WrapperItems: TableItemsWrapper,
  Root: TableRoot,
};
